/*
 * These are the variables that determine what our central data store (`../reducers/index.js`)
 * changes in our state.
 */
// router navagation constant
export var LOCATION_CHANGE = '@@router/LOCATION_CHANGE'; //common constants

export var CLOSE_MODAL = 'CLOSE_MODAL';
export var SENDING_REQUEST = 'SENDING_REQUEST';
export var GET_ERROR = 'GET_ERROR';
export var CLEAR_ERROR = 'CLEAR_ERROR';
export var REQUEST_ERROR = 'REQUEST_ERROR';
/*** Auth ***/

export var LOGOUT = 'LOGOUT';
export var SESSION_EXPIRATION = 'SESSION_EXPIRATION';
export var EXPIRATION_CHECKED = 'EXPIRATION_CHECKED';
export var REFRESH_REQUEST = 'REFRESH_REQUEST';
export var PING_REQUEST = 'PING_REQUEST';
export var SET_CSRFTOKEN = 'SET_CSRFTOKEN';
export var GET_CSRFTOKEN = 'GET_CSRFTOKEN';
export var SET_STAGE = 'SET_STAGE';
export var REFRESH_CHECK_STOP = 'REFRESH_CHECK_STOP';
export var SET_MFA_EXPIRATION = 'SET_MFA_EXPIRATION';
export var REQUEST_SUCCESS = 'REQUEST_SUCCESS';
export var LOADING = 'LOADING';
/*** Modals ***/

export var TIMEOUT_MODAL_STATUS = 'TIMEOUT_MODAL_STATUS';
export var CHANGE_THEME = 'CHANGE_THEME';
export var SET_SNACKBAR_STATUS = 'SET_SNACKBAR_STATUS';
export var FETCH_QUEUES_NAVIGATION = 'FETCH_QUEUES_NAVIGATION';
export var SEARCH_APPLICATION_ID = 'SEARCH_APPLICATION_ID';
export var QUICK_SEARCH_APP_ID = 'QUICK_SEARCH_APP_ID';
export var FETCH_LAST_TEN = 'FETCH_LAST_TEN';
export var SET_MOBILE_STATUS = 'SET_MOBILE_STATUS';
export var SET_LAST_TEN = 'SET_LAST_TEN';
/* NAVIGATION */

export var SET_NAV_LIST = 'SET_NAV_LIST';
/*** ROUTE SAGA FLOW ACtions ***/

export var A_ROUTE_FLOW_DONE = "A_ROUTE_FLOW_DONE";
export var B_ROUTE_FLOW_DONE = "B_ROUTE_FLOW_DONE";